import { combineReducers } from 'redux';

import errorsReducer from './errors';
import mapReducer from './map';
import projectsReducer from './projects';

const reducers = combineReducers({
  errors: errorsReducer,
  map: mapReducer,
  projects: projectsReducer
});

export default reducers;
